import type { ChangedFacetDetails } from 'src/components/organisms/ListingsControlsOptions/types';
import type { Facet, FacetOption } from '../types/Facet';

export const setMultiSelectActiveState = (
  facetOptions: FacetOption[],
  value: FacetOption['value'],
  active: boolean,
): FacetOption[] => {
  return facetOptions.map((option) => {
    if (option.value === value) {
      return {
        ...option,
        active,
      };
    }

    return option;
  });
};

export const setSingleSelectActiveState = (
  facetOptions: FacetOption[],
  value: FacetOption['value'],
  active: boolean,
): FacetOption[] => {
  return facetOptions.map((option) => {
    if (option.value === value) {
      return {
        ...option,
        active,
      };
    } else if (active) {
      return {
        ...option,
        active: false,
      };
    }

    return option;
  });
};

export const applyFacetOptionChangeToFacets = (
  facets: Facet[],
  changedFacet: ChangedFacetDetails,
): Facet[] => {
  const changedFacetOption = changedFacet.options[0];

  if (!changedFacetOption) {
    return facets;
  }

  return facets.map((facet) => {
    if (facet.key !== changedFacet.key) {
      return facet;
    }

    switch (facet.type) {
      case 'multi':
        return {
          ...facet,
          options: setMultiSelectActiveState(
            facet.options,
            changedFacetOption.value,
            changedFacetOption.active,
          ),
        };
      case 'single':
        return {
          ...facet,
          options: setSingleSelectActiveState(
            facet.options,
            changedFacetOption.value,
            changedFacetOption.active,
          ),
        };
      default:
        return facet;
    }
  });
};
